import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types'
import {Col, FormGroup, Input, Label, Row} from "reactstrap";
import {useDefaultEndpoints} from "../../../../../lib/api/useDefaultEndpoints";
import {
    UrlRHF,
    CountryRHF,
    CityRHF,
    PriceCurrencyRHF,
    TimeZonePickerRHF
} from "../../../../common/reactHookFormsFields";
import {TextControllerRHF} from "../../../../generic/fields";
import ConditionalField from "../../../../generic/fields/ConditionalField";
import {maxLength} from "../../../../common/reactHookFormsFields/rules";
import CheckSelector from "../../../../generic/fields/CheckSelector";
import Selector from "../../../../generic/fields/Selector";
import {CHECK_TYPES} from "sv-common/constants/checks";
import {t} from "i18next";
import InfoTooltip from "../../../../generic/InfoTooltip";
import getCountryValue from "../../../../../lib/utils/getCountryValue";
import {onInputCoordinatesMask} from "../../../../../lib/utils/onInputCoordinatesMask";
import TextAreaJsonBlock from "../../../../common/formElements/TextAreaJsonBlock";
import {useHistory, useParams} from "react-router-dom";

const MainInfoBlock = ({state, dispatch, control, errors, isArrival, isSchool, setValue}) => {
    const setAdventureData = (e) => dispatch({type: 'setFormData', payload: e})
    let history = useHistory();
    const isCamp = history.location.pathname.includes('camps');
    const {type} = useParams();
    const isPracticeRu = (state?.is_school && state?.adventure_id?.type === 'russia') || (isSchool && type === 'russia');

    const {getEntries} = useDefaultEndpoints('legal-entities');
    const getEventCategories = useDefaultEndpoints('event-categories').getEntries;
    const [legalEntities, setLegalEntites] = useState([])
    const [eventCategories, setEventCategories] = useState([]);

    const getPublicContracts = useDefaultEndpoints('public-contracts').getEntries;
    const [publicContracts, setPublicContracts] = useState([]);
    const isPartialPayment = !state.partial_payment_option_50 && !state.partial_payment_option_20;
    const [baseId, setBaseId] = useState([]);
    const getBaseId = useDefaultEndpoints('bases').getEntries;

    useEffect(() => {
        getEntries({}).then(res => setLegalEntites(() => res));
        getPublicContracts({}).then(res => setPublicContracts(() => res));
        getEventCategories({}).then(res => setEventCategories(() => [...res]))
        getBaseId({}).then(res => setBaseId(() => res));
    }, [])

    return (<Row>
            <Col xs={12} md={6}>
                <FormGroup>
                    <CountryRHF state={state} setState={e => dispatch({type: 'setFormData', payload: e})}
                            form={{control, errors}}/>
                </FormGroup>
            </Col>
            <Col xs={12} md={6}>
                <Selector control={control} name="legal_entity_id" rules={{required: t('inputs.validation.required')}}
                    defaultValue={state.legal_entity_id?.id || state.legal_entity_id || ''} errors={errors}
                    label={t('adventures.edit.legalEntity')} dispatch={dispatch} items={legalEntities}
                    optionTitle={t('adventures.edit.pickLegalEntity')} optionKey="id" optionValue="id" isRequired={true}
                />
            </Col>
            <Col xs={12} md={6}>
                <FormGroup>
                    <FormGroup>
                        <CityRHF state={state} setState={e => dispatch({type: 'setFormData', payload: e})}
                                    form={{control, errors}}/>
                    </FormGroup>
                </FormGroup>
            </Col>
            <Col xs={4} md={2}>
                <FormGroup>
                    <TextControllerRHF inputName={'total_sits'}
                                       setValue={e => dispatch({type: 'setFormData', payload: e})}
                                       label={t('adventures.edit.totalSits')}
                                       control={control}
                                       errors={errors}
                                       defaultValue={state.total_sits || ''}
                                       placeholder={'10'}
                                       isRequired={true}
                                       rules={{required: t('inputs.validation.required')}}
                                       setValueRHF={setValue}
                                       info={t('common.totalSitsDecrease')}
                                       type={'number'}
                    />
                </FormGroup>
            </Col>
            <Col xs={4} md={2}>
                <FormGroup>
                    <TextControllerRHF inputName={'price_value'}
                                       label={t('adventures.edit.price')}
                                       setValue={e => dispatch({type: 'setFormData', payload: e})}
                                       control={control}
                                       errors={errors}
                                       defaultValue={state.price_value || ''}
                                       placeholder={'1000'}
                                       isRequired={true}
                                       rules={{required: t('inputs.validation.required')}}
                                       setValueRHF={setValue}
                                       type={'number'}
                    />
                </FormGroup>
            </Col>
            <Col xs={4} md={2}>
                <FormGroup>
                    <PriceCurrencyRHF state={state}
                                      setState={e => dispatch({type: 'setFormData', payload: e})}
                                      form={{control, errors}}/>
                </FormGroup>
            </Col>
            <Col xs={12} md={6}>
                <FormGroup>
                    <UrlRHF state={state} setState={e => dispatch({type: 'setFormData', payload: e})}
                            form={{control, errors}} label={`URL ${isArrival
                                ? t('adventures.edit.arrival') : t('adventures.edit.travel')}`}
                            hint={t('adventures.edit.urlHint')} isTrimOnChange={true} />
                </FormGroup>
            </Col>
            {!isArrival && (
                <Col xs={12} md={6}>
                    <Selector control={control} name="event_category" defaultValue={state.event_category || ""}
                    errors={errors} label={t('adventures.edit.eventCategory')} dispatch={dispatch}
                    items={eventCategories} optionTitle={t('adventures.edit.eventCategory')} optionKey="key" optionValue="key"
                    />
                </Col>
            )}
            {isCamp &&
                <Col xs={12} md={6}>
                    <Selector control={control} name="base_id"
                              defaultValue={state.base_id || null} errors={errors} label={t('adventures.edit.baseId')}
                              dispatch={dispatch} items={baseId} optionTitle={t('adventures.edit.pickBaseId')}
                              optionKey="id" optionValue="id"
                    />
                </Col>
            }
            <Col xs={12} md={6}>
                <FormGroup>
                    <UrlRHF
                        state={state}
                        setState={e => dispatch({type: 'setFormData', payload: e})}
                        stateKey="web_url_products"
                        isRequired={true}
                        form={{control, errors}}
                        label={<>
                            {t('bases.base.eventWebUrlProducts')}
                            <InfoTooltip
                                text={<>
                                    <p>{t('bases.base.eventWebUrlProductsHint.title')}</p>
                                    <ul>
                                        {t('bases.base.eventWebUrlProductsHint.examples', { returnObjects: true }).map((item, i) => <li key={i}>{item}</li>)}
                                    </ul>
                                    <p>{t('bases.base.eventWebUrlProductsHint.footer')}</p>
                                </>}
                            />
                        </>}
                        isTrimOnChange={true}
                        isWebValidate={true}
                        placeholder={getCountryValue({
                            ru: 'https://silavetra.com/travel/azores',
                            en: 'https://www.dubai.windrises.com/sailing-experience'
                        })}
                    />
                </FormGroup>
            </Col>
            {isPracticeRu &&
                <Col xs={12} md={6}>
                    <FormGroup>
                        <TextControllerRHF inputName={'tg_link'}
                                           setValue={e => dispatch({type: 'setFormData', payload: e})}
                                           label={t('adventures.edit.telegramLink.label')}
                                           control={control}
                                           errors={errors}
                                           defaultValue={state.tg_link || ''}
                                           placeholder={t('adventures.edit.telegramLink.placeholder')}
                        />
                    </FormGroup>
                </Col>
            }
            <Col xs={12} md={6}>
                <FormGroup inline className={'mb-0'}>
                    <Label check for="partial_payment_option">
                        {t('adventures.edit.partialPayments')}
                    </Label>
                </FormGroup>
                <Row>
                    <ConditionalField condition={!state.is_school && !isSchool}>
                        <Col xs={12} md={4}>
                            <FormGroup check>
                                <input type="checkbox" name="partial_payment_option_20" id="partial_payment_option_20"
                                       checked={state.partial_payment_option_20}
                                       onChange={setAdventureData}
                                />
                                <Label check for="partial_payment_option1" className={'d-inline'}>
                                    20%
                                </Label>
                            </FormGroup>
                        </Col>
                    </ConditionalField>
                    <Col xs={12} md={4}>
                        <FormGroup check>
                            <input type="checkbox" name="partial_payment_option_50" id="partial_payment_option_50"
                                   checked={state.partial_payment_option_50}
                                   onChange={setAdventureData}
                            />
                            <Label check for="partial_payment_option2" className={'d-inline'} >
                                50%
                            </Label>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={4}>
                        <FormGroup check>
                            <input type="checkbox" value={'100%'} checked disabled/>
                            <Label check for="partial_payment_option2" className={'d-inline'} >
                                100%
                            </Label>
                        </FormGroup>
                    </Col>
                </Row>
            </Col>
            <Col xs={12} md={6}>
                <FormGroup>
                    <Label>
                        {t('adventures.edit.partialMarkup')}
                        <InfoTooltip text={t('adventures.edit.partialMarkupInfo')} />
                    </Label>
                    <Input name={'partial_markup'} id={'partial_markup'} value={state?.partial_markup}
                           disabled={isPartialPayment} onChange={setAdventureData}
                           type={'number'} placeholder={t('adventures.edit.partialMarkupPlaceholder')}
                    />
                </FormGroup>
            </Col>
            <Col xs={12} md={6}>
                <FormGroup>
                    <TextAreaJsonBlock control={control} dispatch={dispatch} isRequired={false} disabled={isPartialPayment}
                                       defaultValue={state?.partial_pay_text}
                                       name={'partial_pay_text'} info={t('adventures.edit.partialPayText.info')}
                                       label={t('adventures.edit.partialPayText.label')}
                                       placeholder={t('adventures.edit.partialPayText.placeholder')}/>
                </FormGroup>
            </Col>
            <Col xs={12} md={6}>
                <FormGroup>
                    <Label>{t('adventures.edit.coordinates')}</Label>
                    <Input name={'coordinates'} id={'coordinates'} value={state?.coordinates || ''}
                           onChange={setAdventureData}
                           onInput={onInputCoordinatesMask}
                    />
                </FormGroup>
            </Col>
            <Col xs={12} md={6}>
                <Selector control={control} name="public_contract_url" rules={{required: t('inputs.validation.required')}}
                    defaultValue={state.public_contract_url} errors={errors} label={t('adventures.edit.legalEntities')}
                    dispatch={dispatch} items={publicContracts} optionTitle={t('adventures.edit.pickLegalEntity')}
                    optionKey="id" optionValue="link" optionLabel="tag" isRequired={true}
                />
            </Col>
            <Col xs={12} md={6}>
                <FormGroup>
                    <TextControllerRHF inputName={'payment_description'} control={control} setValue={setAdventureData}
                                       label={t('adventures.edit.paymentDesc')} errors={errors}
                                       defaultValue={state.payment_description || ''}
                                       rules={{...maxLength(100)}}
                                       placeholder={'Big spring regatta SILAVETRA, 01.01 - 01.02.2020, STEPAN PROBKA'}
                                       hint={t('adventures.edit.paymentHint')} setValueRHF={setValue}
                    />
                </FormGroup>
            </Col>
            <Col xs={12} md={6}>
                <FormGroup>
                    <TimeZonePickerRHF form={{control, errors}} setState={setAdventureData} state={state} isRequired/>
                </FormGroup>
            </Col>
            <Col xs={12} md={6}>
                <CheckSelector control={control} dispatch={dispatch} defaultValue={state.check_id?.id}
                               productName={state.name} errors={errors} checkTypes={CHECK_TYPES} deps={[state.name]} />
            </Col>
            <Col xs={12} md={6}>
                <FormGroup>
                    <TextControllerRHF
                        inputName={'taplink'} control={control} setValue={setAdventureData}
                        label={t('adventures.edit.taplink')} errors={errors}
                        placeholder={'https://taplink.by/example'} defaultValue={state.taplink || ''}
                        setValueRHF={setValue}
                    />
                </FormGroup>
            </Col>
        </Row>
    )
}

export default MainInfoBlock;

MainInfoBlock.propTypes = {
    state: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,

}